<template>
  <main class="content content--narrow">

    <div class="content__heading content__heading--center">
      <figure class="fusebox--emblem">
        <img src="@/assets/svg/fusebox_online_emblem.svg"/>
      </figure>
    </div>

    <ValidationObserver ref="form" #default="{ invalid }">
      <div class="panel__container">
        <Panel :title="$t('general.resetPasswordTitle')" size="full">
          <template v-slot:body>
            <form class="form__wrapper" @submit.prevent="resetLink">
              <div class="field__row">
                <Field :label="$t('general.email')" name="email" rules="required|email|max:255" type="text"
                       v-model="form.email"/>
              </div>
              <button class="hidden" type="submit">
                {{ $t('general.login') }}
              </button>
            </form>
          </template>
          <template v-slot:footer>
            <div class="form__footer">
              <div class="btn--bar">
                <button class="btn" :disabled="invalid || submit" @click="resetLink()"
                        type="button">
                  {{ $t('general.resetPasswordButton') }}
                </button>
                <router-link class="btn btn--secondary" :to="{ name: 'auth.register' }">{{
                  $t('general.getNewAccount') }}
                </router-link>
              </div>
            </div>
          </template>
        </Panel>
      </div>
    </ValidationObserver>
  </main>
</template>

<script>
import { errHandler } from '@/helpers'
import Panel from '@/components/Parts/Panel.vue'
import Field from '@/components/Parts/Field'

export default {
  components: { Panel, Field },
  data () {
    return {
      form: {
        email: ''
      },
      submit: false
    }
  },
  methods: {
    async resetLink () {
      if (await this.$refs.form.validate()) {
        try {
          this.submit = true
          await this.$store.dispatch('auth/resetLinkGenerate', this.form)
          this.$router.replace({ name: 'auth.login', query: { sticky: 'resetSuccess' } })
        } catch (e) {
          errHandler(e, this.$toasted, key => this.$t(key))
        } finally {
          this.submit = false
        }
      }
    }
  }
}
</script>
